import React, { useEffect, useState } from "react";
import Logo from "../logo-footer.png";
import mainProducts from "../mainProducts.json";
import { NavLink } from "react-router-dom";
// Import Swiper React components
import {
  EffectFade,
  Autoplay,
  Pagination,
  Scrollbar,
  A11y,
} from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
// Import Swiper styles
import "swiper/scss";
import "swiper/scss/effect-fade";
import "swiper/scss/navigation";
import "swiper/scss/pagination";

const Footer = () => {
  const [hideDiv, setHideDiv] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY;
      const windowHeight = window.innerHeight;
      const docHeight = document.documentElement.scrollHeight;

      if (scrollTop + windowHeight >= docHeight - 10) {
        // Reached bottom (with a small buffer of 10px)
        setHideDiv(true);
      } else {
        setHideDiv(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

   const [slidesPerView, setSlidesPerView] = useState(1);
  return (
    // Footer Start
    <>
      <div className="container-fluid bg-theme-primary footer pt-5 wow fadeIn text-theme-light">
        <div className="container py-4 py-md-5">
          <div className="row g-5">
            <div className="col-lg-4 col-md-6">
              {/* <h3 className="fw-bold text-primary mb-4">Deww <span className="text-secondary">Botanicals Pvt Ltd</span></h3> */}
              <img src={Logo} alt="Deww Botanicals" className="logo-img" />
              <p>
                Plot No 149, Sector 86, Greater Faridabad <br />
                Haryana 121007
              </p>
              <p className="mb-0">
                Contact:{" "}
                <a
                  className="text-theme-light"
                  Using target="_blank" without rel="noreferrer"
                  href="tel:+919873036863"
                >
                  +91 98 7303 6863
                </a>{" "}
                |{" "}
                <a
                  className="text-theme-light"
                  Using target="_blank" without rel="noreferrer"
                  href="tel:+917206683112"
                >
                  +91 72 0668 3112
                </a>
              </p>
              {/* <p className="mb-0">Bulk Order: <a className="text-theme-light" Using target="_blank" without rel="noreferrer" href="mailto:dewwbotanicals@gmail.com">dewwbotanicals@gmail.com</a></p> */}
              <p className="mb-0">
                Email Support:{" "}
                <a
                  className="text-theme-light"
                  Using target="_blank" without rel="noreferrer"
                  href="mailto:dewwbotanicals@gmail.com"
                >
                  dewwbotanicals@gmail.com
                </a>
              </p>
              <p>
                Email Support:{" "}
                <a
                  className="text-theme-light"
                  Using target="_blank" without rel="noreferrer"
                  href="mailto:info@dewwbotanicals.com"
                >
                  info@dewwbotanicals.com
                </a>
              </p>
              <div className="d-flex pt-2">
                <a
                  className="btn btn-square btn-outline-light rounded-circle me-1"
                  Using target="_blank" without rel="noreferrer"
                  href="https://www.instagram.com/deww_botanicals/"
                >
                  <i className="fab fa-instagram"></i>
                </a>
                <a
                  className="btn btn-square btn-outline-light rounded-circle me-1"
                  Using target="_blank" without rel="noreferrer"
                  href="https://www.youtube.com/@DewwBotanicals"
                >
                  <i className="fab fa-youtube"></i>
                </a>
                <a
                  className="btn btn-square btn-outline-light rounded-circle me-0"
                  Using target="_blank" without rel="noreferrer"
                  href="https://www.linkedin.com/company/dewwbotanicals/"
                >
                  <i className="fab fa-linkedin-in"></i>
                </a>
              </div>
            </div>

            <div className="col-6 col-lg-4 col-md-6">
              <h4 className="text-theme-light mb-4">Quick Links</h4>
              {mainProducts.map((oil, index) => {
                return (
                  <NavLink
                    key={index}
                    to={oil.link}
                    className="btn btn-link"
                    activeclassname="active"
                  >
                    {oil.name}
                  </NavLink>
                );
              })}
            </div>

            <div className="col-6 col-lg-4 col-md-6">
              <h4 className="text-theme-light mb-4">Company Info</h4>
              <a className="btn btn-link" Using target="_blank" without rel="noreferrer" href="/about">
                About Us
              </a>
              <a className="btn btn-link" Using target="_blank" without rel="noreferrer" href="/contact">
                Contact Us
              </a>
              <a className="btn btn-link" Using target="_blank" without rel="noreferrer" href="/certifications">
                Certifications
              </a>
              <a className="btn btn-link" Using target="_blank" without rel="noreferrer" href="/tnc">
                Terms & Condition
              </a>
            </div>
            {/* <div className="col-lg-3 col-md-6">
                        <h4 className="text-theme-light mb-4">Newsletter</h4>
                        <p>Dolor amet sit justo amet elitr clita ipsum elitr est.</p>
                        <div className="position-relative mx-auto" style={{maxWidth: '400px'}}>
                            <input className="form-control bg-transparent w-100 py-3 ps-4 pe-5" type="text" placeholder="Your email" />
                            <button type="button" className="btn btn-primary py-2 position-absolute top-0 end-0 mt-2 me-2">SignUp</button>
                        </div>
                    </div> */}
          </div>
        </div>
        <div className="container-fluid copyright">
          <div className="container">
            <div className="row">
              <div className="col-md-6 text-center text-md-start mb-3 mb-md-0">
                &copy;{" "}
                <span className="text-theme-light">
                  Deww Botanicals Pvt Ltd
                </span>
                , All Right Reserved.
              </div>
              <div className="col-md-6 text-center text-md-end">
                Developed By{" "}
                <a Using target="_blank" without rel="noreferrer" href="https://ravee.in/">
                  Ravee.in
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* <div className="brochure-btn">
            <NavLink to="#" className="dropdown-item" activeclassname="active" Using target="_blank" without rel="noreferrer">
                Download Brochure
            </NavLink>
        </div> */}

      {!hideDiv && (
        <div className="floating-icons">
          <div className="whatsApp-icon">
            <NavLink
              to="https://wa.me/7206683112?text=Hi%20Deww%20Botanicals!%0AWe%20are%20searching%20for%20certain%20products."
              className="dropdown-item"
              activeclassname="active"
              Using target="_blank" without rel="noreferrer"
            >
              <img
                src="../assets/images/whatsapp-icon.svg"
                alt="WhatsApp Icon"
              />
            </NavLink>
          </div>

          <div className="certificate-icons">
            <Swiper
              modules={[
                Autoplay,
              ]}
              slidesPerView={slidesPerView}
              style={{ display: 'flex' }}
              loop
              autoplay={{
                delay: 2000,
                disableOnInteraction: false,
              }}
              onSwiper={(swiper) => console.log(swiper)}
            >
              <SwiperSlide>
                <div className="text-center h-100 text-primary category-item">
                <img
                  className="rounded-circle img-fluid mb-2"
                  src="../assets/images/fssai.jpg"
                  alt=""
                />
              </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="text-center h-100 text-primary category-item">
                <img
                  className="rounded-circle img-fluid mb-2"
                  src="../assets/images/msme.jpg"
                  alt=""
                />
              </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="text-center h-100 text-primary category-item">
                <img
                  className="rounded-circle img-fluid mb-2"
                  src="../assets/images/iso.jpg"
                  alt=""
                />
              </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="text-center h-100 text-primary category-item">
                <img
                  className="rounded-circle img-fluid mb-2"
                  src="../assets/images/gst.jpg"
                  alt=""
                />
              </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="text-center h-100 text-primary category-item">
                <img
                  className="rounded-circle img-fluid mb-2"
                  src="../assets/images/gmp.jpg"
                  alt=""
                />
              </div>
              </SwiperSlide>
              </Swiper>
          </div>

          <NavLink
            to="../assets/companyProfile.pdf"
            className="dropdown-item dBrochure-btn"
            activeclassname="active"
            Using target="_blank" without rel="noreferrer"
            download={true}
          >
            Download Brochure
          </NavLink>
        </div>
      )}
    </>
  );
};

export default Footer;
